import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { SfaErrorMessage } from './sfa-error-message';

export const SfaLinkOrgErrorMessage = () => {
  const intl = useIntl();

  const title = intl.formatMessage({
    id: 'onboarding.sfa.link_org_error_message_title',
    defaultMessage: 'We could not link to the Futrli organisation'
  });
  const text = intl.formatMessage(
    {
      id: 'onboarding.sfa.link_org_error_message',
      defaultMessage:
        'Select <bold>Confirm and continue</bold> to try linking again. Alternatively, select <bold>Cancel</bold> to come back and try again later.'
    },
    {
      bold: (chunks: ReactNode) => <b style={{ fontWeight: 500 }}>{chunks}</b>
    }
  );

  return <SfaErrorMessage title={title}>{text}</SfaErrorMessage>;
};
